<script setup lang="ts">
  import BvBtn from '@bv/components/form/button/BvBtn.vue';
  import BvIcon from '@bv/components/icon/BvIcon.vue';
</script>

<template>
  <bv-btn
    class="h-8 w-8 p-0 [&_.v-btn\_\_content]:z-1 [&_.v-btn\_\_overlay]:bg-gray-100 hover:[&_.v-btn\_\_overlay]:opacity-100"
    color="currentcolor"
    rounded="circle"
    variant="text"
  >
    <bv-icon
      icon="bvi-bell"
      size="lg"
    />
  </bv-btn>
</template>
